var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"tooltip",on:{"click":function($event){$event.stopPropagation();}}},[_c('span',{staticClass:"tooltip__toggle"},[_vm._v("?")]),_c('span',{staticClass:"tooltip__box"},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }